import React from 'react'
// import {Link} from 'react-router-dom';
import Header from './Header'
import Topsection from './Topsection';
import Logoslider from './Logoslider'
import Homesection from './Homesection'
import Rightside from './Rightside'
import Ourcourses from './Ourcourses'
import FiveM_formula from './FiveM_formula'
import Footer from './Footer'
import Frontpopup_form from './Frontpopup_form';
import FloatingMenu from './FloatingMenu';
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';

import { Helmet } from 'react-helmet';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Fortune Cloud Technologies | India`s Most Trusted Online & Offline IT Training Institute</title>
        <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
        <meta name="robots" content="index, follow" />
      </Helmet>
      
      <Topsection/>
      <Header/>
      <Homesection/>
      <Logoslider/>
      <Ourcourses/>
      <FiveM_formula/>
      <Footer/>
      {/* <Rightside/> */}
      {/* <FloatingMenu/> */}
      
      <Frontpopup_form/>
      <FloatingButton/>
      <Mobilefooterbtn/>
    </>
  )
}

export default Home